class ColorVector {
  constructor(public r: number, public g: number, public b: number) {}

  static fromHex(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? new ColorVector(
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16)
    ) : null;
  }

  static subtract(v1: ColorVector, v2: ColorVector) {
    return new ColorVector(v2.r - v1.r, v2.g - v1.g, v2.b - v1.b);
  }

  static add(v1: ColorVector, v2: ColorVector) {
    return new ColorVector(v1.r + v2.r, v1.g + v2.g, v1.b + v2.b);
  }

  static multiply(v: ColorVector, value: number) {
    return new ColorVector(
      Math.floor(v.r * value),
      Math.floor(v.g * value),
      Math.floor(v.b * value)
    );
  }

  private componentToHex(c: number) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

  toHex() {
    return '#'.concat(
      this.componentToHex(this.r),
      this.componentToHex(this.g),
      this.componentToHex(this.b),
    );
  }
}

export class Gradient {
  constructor(public colors: string[] = []) {}

  addColorStops(...stops: string[]) {
    this.colors.push(...stops);
    return this;
  }

  getColor(percent: number) {
    if (percent < 0 || percent > 1) {
      throw new Error('Percent should be between 0 and 1.');
    }

    const indexStart = Math.floor((this.colors.length - 1) * percent);
    const vStart = ColorVector.fromHex(this.colors[indexStart]);

    const indexStop = Math.ceil((this.colors.length - 1) * percent);
    const vEnd = ColorVector.fromHex(this.colors[indexStop]);

    percent = percent * (this.colors.length - 1) - indexStart;

    const vSlope = ColorVector.subtract(vStart, vEnd);
    const vColor = ColorVector.add(
      vStart,
      ColorVector.multiply(vSlope, percent)
    );

    return vColor.toHex();
  }

  toArray(nbColors: number) {
    const array: string[] = [];

    if (nbColors === 1) {
      array.push(this.getColor(1));
    } else {
      for (let i = 0; i < nbColors; i++) {
        const percent = i / (nbColors - 1);
        array.push(this.getColor(percent));
      }
    }

    return array;
  }
}
